import '../../../../Assets/app.base';
import renderComponent from '../../../../Assets/scripts/composition/renderComponent';
import './Index.scss';

// Components
import '../../../../Components/Navbar';
import FlatDatePicker from '../../../../Components/FlatDatePicker';
import '../../../../Components/InfiniteScrollView';
import '../../../../Components/NoResultsWarning';
import initPartyphotoComponent from '../../../../Components/PartyphotoAlbumList';

// Controller
function getEventsForDate(date) {
    const dateFormatted = date.toFormat('dd-MM-yy')
    const url = window.partyphotosControllerInit.PartyphotoBaseUrl.replace('01-01-01', dateFormatted)
    window.location.replace(url)
}

function init() {
    const infiniteScrollComponent = $('#album-scroll-container')
    infiniteScrollComponent.on('onContentLoad', function (event, element) {
        initPartyphotoComponent(element)
    })

    renderComponent(FlatDatePicker, document.getElementById('date-picker'), { onDateClick: getEventsForDate })
}

$(function () {
    init()
})